import { FuelTag, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import GenericInfoItem from 'components/ui/GenericInfoItem';
import MapContainer from 'components/ui/Map';
import SkeletonMap from 'components/ui/Map/Skeleton';
import { MarkerInterface } from 'components/ui/Map/types';
import { useMapLoadedStatus } from 'hooks/useMapLoadedStatus';
import { ITrucker } from 'interfaces/profile.interface';
import React from 'react';
import userArea from '../../../../assets/img/user-area.svg';

const IS_NEAR_MAX_DISTANCE = 100;

const LastLocation: React.FC<{
  trucker: ITrucker;
}> = ({ trucker }) => {
  const { isLoaded } = useMapLoadedStatus();

  const makeDistanceTag = () => {
    if (!trucker?.lastLocation?.hasDistance) return null;

    const isNear = trucker?.lastLocation?.distance <= IS_NEAR_MAX_DISTANCE;
    const tagColor = isNear ? 'green' : null;
    const tagLabel = isNear ? 'perto da carga' : 'longe da carga';
    const testId = isNear ? 'test-tag-near' : 'test-tag-far-away';

    return (
      <FuelFlex
        defaultProps={{ justifyContent: 'flex-end' }}
        mdProps={{ justifyContent: 'flex-start' }}
        smProps={{ justifyContent: 'flex-start' }}
      >
        <FuelTag
          label={tagLabel}
          color={tagColor}
          icon="navigation-cursor"
          iconStyle="filled"
          shape="rectangle"
          uppercase
          highlight={isNear}
          data-testid={testId}
        />
      </FuelFlex>
    );
  };

  const getPropsMap = (): MarkerInterface[] => [
    {
      name: trucker?.name,
      avatar: trucker?.selfieUri || userArea,
      coordinates: [trucker?.lastLocation?.coordinates?.latitude, trucker?.lastLocation?.coordinates?.longitude],
      lastLocation: trucker?.lastLocation,
    },
  ];

  const makeDistanceText = () => {
    const timeSinceCollectedText = `Há ${trucker?.lastLocation?.timeSinceCollected}`;
    let distanceText = '';

    if (trucker?.lastLocation?.hasDistance && !trucker?.lastLocation?.isApproximated)
      distanceText = `${trucker?.lastLocation?.distance} Km • `;

    if (trucker?.lastLocation?.hasDistance && trucker?.lastLocation?.isApproximated)
      distanceText = `${trucker?.lastLocation?.distance} Km (aproximadamente) • `;

    return (
      <FuelTypography size="caption" weight="medium" color="neutral-default">
        {distanceText}
        {timeSinceCollectedText}
      </FuelTypography>
    );
  };
  const showMap = !!trucker?.lastLocation?.coordinates?.latitude && !!trucker?.lastLocation?.coordinates?.longitude;

  return (
    <>
      <GenericInfoItem title="Última localização" displayDivider={!showMap}>
        {trucker?.lastLocation?.city && trucker?.lastLocation?.state ? (
          <>
            <FuelTypography weight="medium">
              {trucker?.lastLocation?.city}, {trucker?.lastLocation?.state}
            </FuelTypography>
            {makeDistanceTag()}
            {makeDistanceText()}
          </>
        ) : (
          <FuelTypography weight="medium">Localização indisponível</FuelTypography>
        )}
      </GenericInfoItem>
      {showMap && !isLoaded && <SkeletonMap />}
      {showMap && <MapContainer markers={getPropsMap()} />}
    </>
  );
};

export default LastLocation;
